module.exports = __webpack_public_path__ + "static/media/vf_mouter_core.f94c3e44.svg";